export default function Go_Home () {
  return (
    <div>
      <h1>Go_Home </h1>
      <p>Go Home</p>
    </div>
  );
}